/* eslint-disable @typescript-eslint/no-unused-vars */
import { sessionsQuery } from '../../sessions/queries';
import { createCommand } from '../../utils';
import { moduleName, requestMapBounds } from '../state';

export const ZoomOnOrganizationCommand = createCommand(
    `${moduleName}/ZOOM_ON_ORGANIZATION`,
    async (_, { dispatch, getState }) => {
        const sessions = sessionsQuery(getState());
        const sessionsWithBBox = sessions.filter((session) => session.bbox !== null);

        if (sessionsWithBBox.length > 0) {
            const minX = Math.min(...sessionsWithBBox.map((session) => session.bbox![0]));
            const minY = Math.min(...sessionsWithBBox.map((session) => session.bbox![1]));
            const maxX = Math.max(...sessionsWithBBox.map((session) => session.bbox![2]));
            const maxY = Math.max(...sessionsWithBBox.map((session) => session.bbox![3]));

            dispatch(requestMapBounds([minX, minY, maxX, maxY]));
        }
    },
);
